import axios from 'axios';
import { reset as resetForm, initialize, destroy } from 'redux-form';
import { BASE_API, USER_TOKEN } from 'config/consts';
import _ from 'lodash';
import types from './types';
import researchTypes from '../research/types';
import { normalizeCopaSarauScheduleFields, parseCopaSarauStationConfig } from './config';

const URL_ACTION = `${BASE_API}/actions`;

export const submitAction = (
  actionValues,
  router = undefined,
  create_or_update,
  id = undefined,
  publishAction
) => {
  return (dispatch) => {
    dispatch([
      { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);

    if (create_or_update === 'create') {
      axios
        .post(`${URL_ACTION}`, actionValues, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
          onUploadProgress: (progressEvent) =>
            dispatch([
              {
                type: 'SUBMIT_PROGRESS',
                payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
              },
            ]),
        })
        .then(() => {
          dispatch([
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            { type: 'SUBMIT_PROGRESS', payload: 0 },
            {
              type: 'SNACKBAR',
              payload: {
                message: 'Operação realizada com sucesso',
                variant: 'success',
                open: true,
              },
            },
            destroyForm(),
          ]);
          router.push('/owner');
        })
        .catch((e) => {
          dispatch([
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            { type: 'SUBMIT_PROGRESS', payload: 0 },
          ]);
          try {
            for (const i in e.response.data) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${e.response.data[i]}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          } catch (error) {
            dispatch({
              type: 'SNACKBAR',
              payload: { message: 'Erro', variant: 'error', open: true },
            });
          }
        });
    } else if (create_or_update === 'update') {
      axios
        .put(`${URL_ACTION}/${id}`, actionValues, {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        })
        .then(() => {
          if (publishAction) {
            dispatch([publishAction()]);
          } else {
            dispatch([
              { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
              { type: 'SUBMIT_PROGRESS', payload: 0 },
              destroyForm(),
            ]);
            if (router) {
              router.push('/owner/acoes/minhas-atividades');
            }
          }
        })
        .catch((e) => {
          dispatch([
            { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
            { type: 'SUBMIT_PROGRESS', payload: 0 },
          ]);
          try {
            for (const i in e.response.data) {
              dispatch({
                type: 'SNACKBAR',
                payload: {
                  message: `${e.response.data[i]}`,
                  variant: 'error',
                  open: true,
                },
              });
            }
          } catch (error) {
            dispatch({
              type: 'SNACKBAR',
              payload: { message: 'Erro', variant: 'error', open: true },
            });
          }
        });
    }
  };
};

export const getDetail = (id) => {
  return (dispatch) => {
    dispatch({
      type: researchTypes.CONTACTS_SURVEY_LOAD,
      payload: 'pending',
    });
    axios
      .get(`${URL_ACTION}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const { target } = response.data;
        const categories = response.data.category_actions?.map((item) => ({
          id: item.category?.id,
          title: item.category?.name,
        }));
        const groupings = response.data.action_grouping?.map((item) => ({
          id: item.grouping?.id,
          title: item.grouping?.name,
        }));
        const obj = response.data;
        const parsedConfig = parseCopaSarauStationConfig(
          response.data.station_specific_data || response.data.body
        );

        const newQuestionsList = obj.researches?.[0]?.questions?.map((question) => ({
          ...question,
          options: question.options.map((item) => ({
            label: { text: item.label, id: item.id },
            correct: item.correct,
          })),
          question: { id: question.id, text: question.question },
          type: question.type_id,
        }));

        const initialValues = {
          ...obj,
          ...parsedConfig,
          categories_field: categories,
          groupings_field: groupings,
          questions: newQuestionsList,
          body_name: obj.name,
          body_description: obj.description,
          body_summary: obj.summary,
          description: obj.description,
          summary: obj.summary,
          station_specific_data: parsedConfig,
          copa_sarau_config: parsedConfig.copa_sarau_config,
          companion_price:
            obj.companion_price ||
            parsedConfig.body_valor_acompanhante ||
            parsedConfig.copa_sarau_config.room_rules.first_room.companion_price,
          extra_room_price:
            obj.extra_room_price ||
            parsedConfig.body_valor_quarto_extra ||
            parsedConfig.copa_sarau_config.room_rules.additional_room.room_price,
          room_limit:
            obj.room_limit ||
            parsedConfig.body_max_per_room ||
            parsedConfig.copa_sarau_config.room_rules.room_people_limit,
          from: target?.age ? target.age.from : null,
          to: target?.age ? target.age.to : null,
          states: target?.states,
          entities: target?.entities,
          videoIdField:
            response.data.action_videos?.length > 0
              ? response.data.action_videos[0].video_id
              : null,
          associated: target?.associated,
          internal: target?.internal,
          segmentation_type: target?.segment_users ? 'users' : 'public',
          segment_users: target?.segment_users || [],
          has_giveaway: response.data.giveaway_number_rules?.length > 0,
          giveaway_quantity:
            response.data.giveaway_number_rules?.length > 0
              ? response.data.giveaway_number_rules[0].quantity
              : null,
          giveaway_id:
            response.data.giveaway_number_rules?.length > 0
              ? response.data.giveaway_number_rules[0].giveaway_id
              : null,
          isThereTrophy: !!response.data.trophy_description,
        };
        const normalizedInitialValues = normalizeCopaSarauScheduleFields(initialValues, {
          forForm: true,
        });
        if (!normalizedInitialValues.points || parseFloat(normalizedInitialValues.points) === 0) {
          normalizedInitialValues.isPaid = false;
        } else {
          normalizedInitialValues.isPaid = true;
        }
        dispatch([
          initializeForm(normalizedInitialValues),
          {
            type: researchTypes.CONTACTS_SURVEY_DETAIL,
            payload: obj,
          },
        ]);
      })
      .catch(() => {
        dispatch({
          type: researchTypes.CONTACTS_SURVEY_LOAD,
          payload: 'rejected',
        });
      });
  };
};

export const initializeForm = (values) => {
  return initialize('contactsSurveysForm', values);
};

export const initializeFormQuestions = (questions) => {
  return (dispatch, getState) => {
    const currentValues = getState().form?.contactsSurveysForm?.values || {};
    dispatch(initialize('contactsSurveysForm', { ...currentValues, questions }));
  };
};

export const initializeFormCopaSarauDefaults = (defaultQuestions) => {
  return (dispatch, getState) => {
    const currentValues = getState().form?.contactsSurveysForm?.values || {};
    const defaultConfig = parseCopaSarauStationConfig();
    dispatch(
      initialize('contactsSurveysForm', {
        ...currentValues,
        ...defaultConfig,
        copa_sarau_config: defaultConfig.copa_sarau_config,
        questions: defaultQuestions,
      })
    );
  };
};

export const dispatchFormReset = () => {
  return (dispatch) => {
    dispatch(destroy('contactsSurveysForm'));
  };
};

export const destroyForm = () => {
  return destroy('contactsSurveysForm');
};

export const savePartialy = (values, router, setValue, value) => {
  const { id } = router.params;
  return (dispatch) => {
    dispatch([
      { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);
    axios
      .put(`${URL_ACTION}/${id}`, values, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
        onUploadProgress: (progressEvent) =>
          dispatch([
            {
              type: 'SUBMIT_PROGRESS',
              payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
            },
          ]),
      })
      .then(() => {
        dispatch([
          { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
          { type: 'SUBMIT_PROGRESS', payload: 0 },
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
          setValue(value + 1),
        ]);
      })
      .catch((e) => {
        dispatch([
          { type: 'ACTIVE_ACTIONS_BUTTON_LOAD', payload: false },
          { type: 'SUBMIT_PROGRESS', payload: 0 },
        ]);
        try {
          for (const i in e.response.data) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `${e.response.data[i]}`,
                variant: 'error',
                open: true,
              },
            });
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
};
